export default "__VITE_ASSET__0a0d41dd__"